// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xj_a bhn_vp bhn_vh bhn_xe bhn_rg bhn_tr bhn_qx"};